import styled from 'styled-components';
const SummaryWrapper = styled.div`
.Summary-wrapper{
    height:500px;
    background-image: linear-gradient(to bottom, #f9fdff 0%, rgba(249, 253, 255, 0) 100%), linear-gradient(to bottom, #fff, #fff);
}
.Summary-wrapperar .top-message{
    text-align: right;
}

.top-message{
    text-align: initial;
    img{
        width: 128px;
        height: 128px;
    }
     p{
  font-size: 32px;
  font-weight: 800;
  font-stretch: normal;
  color: #34a853;
        }
        span{
            font-size: 17px;
            color: #4c565c;
        }
        .box-button{
            padding: 8px 10px;
            border-radius: 8px;
            background-color: #6B47F5;
            color:#fff;
            border: 1px solid #6B47F5;
            margin-top: 25px;
            img{
                height: 24px; width: 24px; margin-right:10px;
            }
        }.box-button-top{
            border-radius: 5px;
            padding: 8px 10px;
            margin-top: 25px;
            border: solid 1px #6B47F5;
            background-color: #6B47F5;
        }
        
        .top-message-alt{
        img{
            height:24px;
            width:24px;
        }
    }
    }

@media only screen and (max-width: 768px) {
    .Summary-wrapperar .box-button-top{
        text-align: center;
    }
    .top-message{
        text-align: center;
        img{
            width: 92px;
            height: 92px;
        }
        p{
            font-size: 21px;
            font-weight: 500;
        }
        span{
            font-size: 14px;
        }.box-button{
            padding: 8px 10px;
            border-radius: 8px;
            background-color: #6B47F5;
            color:#fff;
            border: 1px solid #6B47F5;
            margin-top: 25px;
        }.box-button-top{
            border-radius: 5px;
            padding: 8px 10px;
            margin-top: 25px;
            border: solid 1px #6B47F5;
            background-color: #6B47F5;
        }
    }
  
}
@media only screen and (max-width: 576px) {
    .Summary-wrapperar .box-button-top{
        text-align: center;
    }
    .top-message{
        text-align: center;
        img{
            width: 92px;
            height: 92px;
        }
        p{
            font-size: 21px;
            font-weight: 500;
        }
        span{
            font-size: 14px;
        }.box-button{
            padding: 8px 10px;
            border-radius: 8px;
            background-color: #6B47F5;
            color:#fff;
            border: 1px solid #6B47F5;
            margin-top: 25px;
        }.box-button-top{
            border-radius: 5px;
            padding: 8px 10px;
            margin-top: 25px;
            border: solid 1px #6B47F5;
            background-color: #6B47F5;
        }
    }
}

.DWN_BTN{
    .download-link {
        text-decoration: none;
      }
      .download {
        display: flex;
        flex-direction: row;
        align-items: start;
        padding: 24px;
        gap: 24px;
        background: #FFFFFF;
        border-radius: 8px;
        margin-top: 24px;
        margin-bottom: 50px;
      }
      .policy-download {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .policy-download-title {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        color: #1A1C1F;
      }
      .policy-download-description {
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 18px;
        color: #1A1C1F;
      }
    
}


  @media screen and (max-width: 768px) {
    

  }
`;
export default SummaryWrapper;